import {
  Component, DestroyRef, ElementRef,
  EventEmitter,
  forwardRef,
  inject,
  Input,
  NgZone,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { ToolBarModule, ToolBarToolComponent } from '@progress/kendo-angular-toolbar';
import { SliderModule } from '@progress/kendo-angular-inputs';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ButtonModule, DropDownButtonModule } from '@progress/kendo-angular-buttons';
import { FormsModule } from '@angular/forms';
import { PopupModule } from '@progress/kendo-angular-popup';
import { NgClass } from '@angular/common';
import { IconComponent } from '../../../../../../../../shared/components/ui/icon/icon.component';
import { DocumentEventsService } from 'src/app/shared/services/document-events/document-events.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'bizz-custom-canvas-toolbar-draw-line',
  standalone: true,
  imports: [
    SliderModule,
    DropDownsModule,
    ToolBarModule,
    DropDownButtonModule,
    FormsModule,
    ButtonModule,
    PopupModule,
    NgClass,
    IconComponent
  ],
  templateUrl: './custom-canvas-toolbar-draw-line.component.html',
  styleUrl: './custom-canvas-toolbar-draw-line.component.scss',
  providers: [{ provide: ToolBarToolComponent, useExisting: forwardRef(() => CustomCanvasToolbarDrawLineComponent) }]
})
export class CustomCanvasToolbarDrawLineComponent extends ToolBarToolComponent {
  @ViewChild('toolbarTemplate', { static: true }) public override toolbarTemplate: TemplateRef<any>;
  @ViewChild('popupTemplate', { static: true }) public override popupTemplate: TemplateRef<any>;
  @Input({required: true}) public value : number;
  @Output() public valueChange = new EventEmitter<number>();

  @ViewChild("anchor", { read: ElementRef }) public anchor: ElementRef;
  @ViewChild("popup", { read: ElementRef }) public popup: ElementRef;

  private documentEventsService = inject(DocumentEventsService);
  private ngZone: NgZone = inject(NgZone);
  private destroyRef: DestroyRef = inject(DestroyRef);
  public constructor() {
    super();

    this.documentEventsService.documentClickEvent.
        pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(
            (event: Event) => {
                if(event?.target && this.checkHandleClick(event.target)) {
                    this.ngZone.run(() => { this.onDocumentClick(event) });
                }
        });
  }

  private checkHandleClick(target: EventTarget): boolean {
    return this.popup 
    && !this.popup.nativeElement.contains(target) 
    && !this.anchor.nativeElement.contains(target);
  }
  public onDocumentClick(event: Event): void {
    this.show = false;
  }

  public onValueChange(): void {
    this.valueChange.emit(this.value);
  }

  public show = false;
  public onToggle(): void {
   this.show = !this.show;
  }
}